import { IconButton, Spinner, UIHeading3, UIText1 } from '@cian/ui-kit';
import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { NBSP } from 'shared/constants';

import * as styles from './NewbuildingBrokerSidebarBanner.css';
import keyImageUrl from './assets/key.png';

interface INewbuildingBrokerSidebarBannerProps {
  loading: boolean;
  onClick: () => void;
}

export const NewbuildingBrokerSidebarBanner: React.FC<INewbuildingBrokerSidebarBannerProps> = ({
  loading,
  onClick,
}) => {
  const handleClick = React.useCallback(() => {
    if (!loading) {
      onClick();
    }
  }, [loading, onClick]);

  const icon = loading ? (
    <Spinner color="icon-main-default" size={16} />
  ) : (
    <IconActionArrowRight16 color="icon-main-default" />
  );

  return (
    <div
      className={styles['container']}
      onClick={handleClick}
      data-testid="NewbuildingBrokerSidebarBanner"
      tabIndex={0}
    >
      <img className={styles['image']} src={keyImageUrl} width="64" height="64" />
      <div className={styles['text-info']}>
        <UIHeading3>Бесплатно найдём новостройку</UIHeading3>
        <UIText1 color="text-secondary-default">
          И{NBSP}поможем на{NBSP}сделке
        </UIText1>
      </div>
      <div className={styles['icon-button-wrapper']}>
        <IconButton icon={icon} aria-label="Заполнить заявку" />
      </div>
    </div>
  );
};
